import anime from 'animejs';
import { SplitText } from '@/assets/libs/SplitText';

export function navigationItemInit(el) {
  const ctx = el instanceof HTMLElement ? el : el.node;
  const pos = ctx.dataset.navposition;
  const line = ctx.querySelector('line');
  const text = ctx.querySelector('p');
  const split = new SplitText(text, { type: 'chars', charsClass: 'paragraph__char' });

  anime.set(line, { scaleX: 0, transformOrigin: pos === 'left' ? '100% 50% 0' : '0% 50% 0' });
  anime.set(split.chars, { translateX: (pos === 'left' ? 1 : -1) * 50, opacity: 0 });
}

export function navigationItemAnim(el, delay = 0) {
  const ctx = el instanceof HTMLElement ? el : el.node;
  const pos = ctx.dataset.navposition;
  const line = ctx.querySelector('line');
  const letters = [...ctx.querySelectorAll('.paragraph__char')];
  const tl = anime.timeline({ delay });

  tl.add({
    targets: line,
    scaleX: 1,
    duration: 800,
    easing: 'easeInOutSine',
  }, 0)
    .add({
      targets: letters,
      translateX: 0,
      opacity: 1,
      duration: 2400,
      delay: anime.stagger(100, {
        from: pos === 'left' ? 'last' : 'first',
      }),
      complete: () => {
        ctx.setAttribute('data-animated', '');
      },
    }, '-=600');

  return tl;
}

export function navigationItemOut(el, delay = 0) {
  const ctx = el instanceof HTMLElement ? el : el.node;
  const pos = ctx.dataset.navposition;
  const line = ctx.querySelector('line');
  const letters = [...ctx.querySelectorAll('.paragraph__char')];
  const tl = anime.timeline({ delay });
  anime.set(line, { transformOrigin: pos === 'left' ? '0% 50% 0' : '100% 50% 0' });

  tl.add({
    targets: line,
    scaleX: 0,
    duration: 300,
    easing: 'easeInOutSine',
  }, 0)
    .add({
      targets: letters,
      translateX: (pos === 'left' ? -1 : 1) * 50,
      opacity: 0,
      duration: 1800,
      delay: anime.stagger(80, {
        from: pos === 'left' ? 'last' : 'first',
      }),
      complete: () => {
        ctx.setAttribute('data-animated', '');
      },
    }, '-=100');

  return tl;
}

export function navigationItemHoverIn(el) {
  const ctx = el instanceof HTMLElement ? el : el.node;
  const pos = ctx.dataset.navposition;
  const letters = [...ctx.querySelectorAll('.paragraph__char')];

  anime.remove(letters);
  const tween = anime({
    targets: letters,
    translateX: [
      { value: (pos === 'left' ? -1 : 1) * 20, duration: 200, easing: 'easeOutSine' },
      { value: 0, duration: 300, easing: 'easeInSine' },
    ],
    delay: anime.stagger(30, {
      from: pos === 'left' ? 'last' : 'first',
    }),
  });

  return tween;
}

export function navigationItemHoverOut(el) {
  const ctx = el instanceof HTMLElement ? el : el.node;
  const letters = [...ctx.querySelectorAll('.paragraph__char')];

  anime.remove(letters);
  const tween = anime({
    targets: letters,
    translateX: 0,
    duration: 250,
    easing: 'easeOutSine',
    delay: anime.stagger(30),
  });

  return tween;
}
